import { Api } from '@/api/api';
import { Approval } from '@/models/approval';
import { ApprovalFilters } from '@/models/approval-filters';
import { PagedApprovalResult } from '@/models/paged-approval-result';
import { ApprovalHistory } from '@/models/approval-history';

export class ApprovalApi extends Api {
    public async fetchForUserAsync(userId: number, filters: ApprovalFilters): Promise<PagedApprovalResult> {
        return await this.getAsync<PagedApprovalResult>(`v2/user/${userId}/approvals`, filters);
    }
    public async fetchAsync(filters: ApprovalFilters): Promise<PagedApprovalResult> {
        return await this.getAsync<PagedApprovalResult>('v2/approval', filters);
    }
    public async fetchByIdAsync(id: string): Promise<Approval> {
        return await this.getAsync<Approval>('v2/approval/' + id);
    }
    public async fetchHistoryByIdAsync(id: string): Promise<Array<ApprovalHistory>> {
        return await this.getAsync<Array<ApprovalHistory>>(`v2/approval/${id}/history`);
    }
    public async acceptAsync(id: string): Promise<void> {
        await this.putAsync('v2/approval/' + id, { id: id, approved: true });
    }
    public async rejectAsync(id: string): Promise<void> {
        await this.putAsync('v2/approval/' + id, { id: id, approved: false });
    }
}
